import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  base: '/inspired-virtual-sports-retail/',
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */'@/views/Home'),
      children: [
        {
          path: '/betting',
          name: 'betting',
          components: {
            default: () => import(/* webpackChunkName: "home" */'@/views/Home'),
            home: () => import(/* webpackChunkName: "betting" */'@/components/BettingBox'),
          },
        },
        {
          path: '/offer',
          name: 'offer',
          components: {
            default: () => import(/* webpackChunkName: "home" */'@/views/Home'),
            home: () => import(/* webpackChunkName: "offer" */'@/components/OfferBox'),
          },
          children: [
            {
              path: '/fulloffer',
              name: 'fullOffer',
              components: {
                default: () => import(/* webpackChunkName: "home" */'@/views/Home'),
                home: () => import(/* webpackChunkName: "offer" */'@/components/OfferBox'),
                offer: () => import(/* webpackChunkName: "fullOffer" */'@/components/FullOfferBox'),
              },
            },
            {
              path: '/betoffer',
              name: 'betOffer',
              components: {
                default: () => import(/* webpackChunkName: "home" */'@/views/Home'),
                home: () => import(/* webpackChunkName: "offer" */'@/components/OfferBox'),
                offer: () => import(/* webpackChunkName: "betOffer" */'@/components/BetOfferBox'),
              },
            },
          ],
        },
      ],
    },
    {
      path: '/print',
      name: 'print',
      component: () => import(/* webpackChunkName: "print" */'@/views/Print'),
      children: [
        {
          path: '/printResults',
          name: 'printResults',
          components: {
            default: () => import(/* webpackChunkName: "print" */'@/views/Print'),
            print: () => import(/* webpackChunkName: "printResults" */'@/components/PrintResults'),
          },
        },
        {
          path: '/printOffer',
          name: 'printoffer',
          components: {
            default: () => import(/* webpackChunkName: "print" */'@/views/Print'),
            print: () => import(/* webpackChunkName: "printOffer" */'@/components/PrintOffer'),
          },
        },
      ],
    },
    {
      path: '/nofeed',
      name: 'nofeed',
      component: () => import(/* webpackChunkName: "noFeed" */'@/views/NoFeed'),
    },
  ],
});
